export const findNotDisabledElement = _ref => {
  let {
    target,
    reverse,
    startWithTarget
  } = _ref;
  const sibling = reverse ? target.previousElementSibling : target.nextElementSibling;
  const element = startWithTarget ? target : sibling;
  if (!element) {
    return null;
  }
  if (typeof element.getAttribute('disabled') === 'string') {
    return findNotDisabledElement({
      target: element,
      reverse
    });
  }
  return element;
};